import React from 'react';
import PropTypes from 'prop-types';
import PersonTeaserBlock from 'components/person-teaser-block';

const BoardBlock = ({ items }) => {
  return items && items.length > 0 ? (
    <div className="board-block">
      <div className="board-block__container">
        <div className="board-block__grid">
          {items.map((item, index) => (
            <PersonTeaserBlock
              key={index}
              {...item}
              className="board-block__item"
            />
          ))}
        </div>
      </div>
    </div>
  ) : null;
};

BoardBlock.propTypes = {
  items: PropTypes.arrayOf(PropTypes.exact(PersonTeaserBlock.propTypes)),
};

export default BoardBlock;
